// extracted by mini-css-extract-plugin
export default {"videoLink":"VideoLink_videoLink__-UV94","del":"VideoLink_del__UdBUC","error":"VideoLink_error__4R6lu"};